import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {
    observeBazaarvoiceJsonLdFragments,
    removeBazaarvoiceJsonLdFragments
} from '../../utills/bazaarvoiceJsonLd'

const BazaarvoiceTracker = () => {
    useEffect(() => {
        const {app: appConfig} = getConfig()
        const clientName = appConfig?.bazaarvoice?.customerName
        const deploymentZone = appConfig?.bazaarvoice?.deploymentZone
        const environment = appConfig?.bazaarvoice?.environment || 'staging'

        if (!clientName || !deploymentZone || !environment) {
            return
        }

        const existingBv = window.$BV || window.BV
        if (existingBv?.pixel && !window.$BV) {
            window.$BV = existingBv
        }

        const prevCallback = window.bvCallback
        window.bvCallback = (BV) => {
            window.$BV = BV
            removeBazaarvoiceJsonLdFragments()
            if (typeof prevCallback === 'function') {
                prevCallback(BV)
            }
        }

        if (!document.getElementById('bv-loader')) {
            const zoneId = deploymentZone.toLowerCase().replace(/\s+/g, '_')
            const env = environment.toLowerCase()
            const script = document.createElement('script')
            script.id = 'bv-loader'
            script.src = `https://apps.bazaarvoice.com/deployments/${clientName}/${zoneId}/${env}/en_US/bv.js`
            script.async = true
            document.head.appendChild(script)
        }

        const styleId = 'bv-modal-layering'
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style')
            style.id = styleId
            style.textContent = `
                .bv_modal_component_container,
                [class*="bv-submission"],
                [class*="bv_submission"],
                [id*="bv"][role="dialog"] {
                    z-index: 9999 !important;
                }
            `
            document.head.appendChild(style)
        }

        const stopObservingJsonLd = observeBazaarvoiceJsonLdFragments()
        return () => {
            stopObservingJsonLd()
        }
    }, [])

    return null
}

export default BazaarvoiceTracker
